import { Box, Text, Link, Octicon } from '@primer/react'
import { InfoIcon } from '@primer/octicons-react'

import tysmIcon from './images/tysm_logo.png'

function LegalPage() {
    return (
        <Box
            sx={{
                bg: 'canvas.default',
                width: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'leading',
                alignItems: 'leading',
                p: 2,
            }}
        >
            <Box
                sx={{
                    textAlign: 'leading',
                    p: 2,
                    my: 0,
                }}
            >
                <Text
                    as="p"
                    sx={{
                        fontSize: 4,
                        fontWeight: 600,
                        ml: 2,
                    }}
                >
                    FLIPSIDE – Privacy Policy (v1)
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    Last updated: 3 December 2025
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    This Privacy Policy explains how tysm (“we”, “us”, “our”) collects, uses, and protects personal information when you play FLIPSIDE or interact with our services.
We are based in the United Kingdom and process personal data in accordance with the UK GDPR, the Data Protection Act 2018, and other applicable privacy laws.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    If you have any questions about this policy, you can contact us at:
'datareq@tysm.one'.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 4,
                        fontWeight: 600,
                        ml: 2,
                    }}
                >
                    1. Information We Collect
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    We collect only the information necessary to operate FLIPSIDE, provide online functionality, and maintain game stability.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 3,
                        fontWeight: 500,
                        ml: 2,
                    }}
                >
                    1.1 Information From Epic Online Services (EOS)
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                    }}
                >
                    When you log in using your Epic Games account, we receive the following information from Epic Online Services: Display name, Language preferences, Linked account display names (e.g., Steam, PlayStation, etc., if linked), Online status, Country and your Epic Games friends list.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    We do not receive your email address, password, payment information, or sensitive data from your Epic Games account.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 3,
                        fontWeight: 500,
                        ml: 2,
                    }}
                >
                    1.2 Crash Reports and Diagnostic Data (Sentry)
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                    }}
                >
                    If FLIPSIDE crashes, the Unreal Engine Crash Reporter automatically generates a crash report that can be sent to Sentry, our error monitoring service, upon the users consent.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                    }}
                >
                    Crash reports may include: Device/platform information, Operating system version, Game version, Log files leading up to the crash, Hardware information (e.g., CPU/GPU model) and Anonymous crash identifiers.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    Crash reports do not contain any data unrelated to the crash.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 3,
                        fontWeight: 500,
                        ml: 2,
                    }}
                >
                    1.3 Automatically Collected Technical Information
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    During gameplay and online interactions, we may collect technical information such as: Platform type (PC, console, etc.), IP address (used for security and networking), Session identifiers and Basic performance metrics required for online functionality.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 4,
                        fontWeight: 600,
                        ml: 2,
                    }}
                >
                    2. How We Use Your Information
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    We process your information for the following purposes:
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 3,
                        fontWeight: 500,
                        ml: 2,
                    }}
                >
                    2.1 To Provide and Operate Online Features
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    Logging in via Epic Games account, Displaying your Epic Games profile name and online status, Showing your friends list, Language/localisation adjustments and Enabling multiplayer and social features.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 3,
                        fontWeight: 500,
                        ml: 2,
                    }}
                >
                    2.2 To Improve Game Stability and Performance
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    Detecting and diagnosing crashes, Fixing bugs and technical issues and Ensuring compatibility across hardware and platforms.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 3,
                        fontWeight: 500,
                        ml: 2,
                    }}
                >
                    2.3 To Maintain Security and Prevent Abuse
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    Ensuring legitimate account access, Preventing cheating or misuse and Protecting online services.
                </Text>
                <Text
                    as="p"
                    sx={{
                        fontSize: 2,
                        ml: 2,
                        mb: 3,
                    }}
                >
                    We never sell your personal data or use it for targeted advertising.
                </Text>
            </Box>
        </Box>
    )
}

export default LegalPage